export interface CompatibilityCheck {
  feature: string;
  supported: boolean;
  critical: boolean;
  description: string;
}

export function checkBrowserCompatibility(): CompatibilityCheck[] {
  const checks: CompatibilityCheck[] = [
    {
      feature: 'Web Bluetooth',
      supported: 'bluetooth' in navigator,
      critical: true,
      description:
        'Required to connect to your smart trainer and heart rate monitor',
    },
    {
      feature: 'Service Workers',
      supported: 'serviceWorker' in navigator,
      critical: false,
      description: 'Enables offline functionality and better performance',
    },
    {
      feature: 'Wake Lock API',
      supported: 'wakeLock' in navigator,
      critical: false,
      description: 'Keeps your screen on during workouts',
    },
    {
      feature: 'Modern JavaScript',
      supported: typeof Promise !== 'undefined' && typeof fetch !== 'undefined',
      critical: true,
      description: 'Required for app functionality',
    },
  ];

  return checks;
}

export function isCompatibleBrowser(): boolean {
  const checks = checkBrowserCompatibility();
  return checks
    .filter((check) => check.critical)
    .every((check) => check.supported);
}

export function getRecommendedBrowsers(): Array<{
  name: string;
  reason: string;
}> {
  return [
    {
      name: 'Google Chrome (Desktop)',
      reason: 'Full Web Bluetooth support for all trainer types',
    },
    {
      name: 'Microsoft Edge (Chromium)',
      reason: 'Complete feature support including Web Bluetooth',
    },
    {
      name: 'Chrome on Android',
      reason: 'Mobile support with Web Bluetooth capability',
    },
  ];
}
